import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';

export class StepButton extends StepBase
{
	/**
	   *  Process the data type here.
	   *  Load the data related to the Query data type.
	   */
	async processStep(logic: LogicEngine): Promise<boolean>
	{
		await super.processStep(logic);
		return true;
	}

}
